import script from "./ConfirmationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmationDialog.vue?vue&type=style&index=0&id=3165fd25&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3165fd25"]])

export default __exports__